/**
 * Layout constants for flow visualization.
 * Ported from Python styles.py.
 */

/** Horizontal spacing between columns (levels) in pixels */
export const COLUMN_WIDTH = 400;

/** Vertical gap between nodes in pixels */
export const NODE_GAP = 20;

/** Y offset for the first node */
export const Y_START = 50;

/** Node width in pixels */
export const NODE_WIDTH = 310;

/**
 * Session color palette for cross-session continuation.
 * Index 0 = original session (default styling).
 * Index 1+ = continuation sessions with distinct tints.
 */
export const SESSION_COLORS = [
  { bg: 'bg-white', border: 'border-slate-200', accent: null },
  { bg: 'bg-blue-50', border: 'border-blue-300', accent: '#3b82f6' },
  { bg: 'bg-emerald-50', border: 'border-emerald-300', accent: '#10b981' },
  { bg: 'bg-purple-50', border: 'border-purple-300', accent: '#8b5cf6' },
  { bg: 'bg-amber-50', border: 'border-amber-300', accent: '#f59e0b' },
] as const;
